import { useEffect, ReactNode } from 'react';
import { useRouter } from 'next/router';
import { initPostHog, trackPageView } from '../lib/posthog';

interface PostHogProviderProps {
  children: ReactNode;
}

export default function PostHogProvider({ children }: PostHogProviderProps) {
  const router = useRouter();

  useEffect(() => {
    // Initialize PostHog
    initPostHog();
  }, []);

  useEffect(() => {
    // Track page views on route changes
    const handleRouteChange = (url: string) => {
      trackPageView(url);
    };

    // Track initial page view
    trackPageView();

    // Listen for route changes
    router.events.on('routeChangeComplete', handleRouteChange);

    // Cleanup
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);

  return <>{children}</>;
}
